/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQQuestion } from './mCQQuestion';
import type { MCQConfigOutputQuestionsToShow } from './mCQConfigOutputQuestionsToShow';
import type { MCQConfigOutputTimeLimitMinutes } from './mCQConfigOutputTimeLimitMinutes';

/**
 * MCQ config for a task.
 */
export interface MCQConfigOutput {
  questions: MCQQuestion[];
  questionsToShow?: MCQConfigOutputQuestionsToShow;
  passThresholdPercent?: number;
  shuffleQuestions?: boolean;
  shuffleOptions?: boolean;
  showImmediateFeedback?: boolean;
  timeLimitMinutes?: MCQConfigOutputTimeLimitMinutes;
}
